var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h4',[_vm._v("Lista de Roles y permisos ")])]),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('form-roles')],1),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('lista-roles')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }